import { IStoreEntityStateSlice, createEntitySlice, IStoreListStateSlice, createListSlice } from '@aston/foundation';
import { IFilter } from '@aston/foundation';
import { UserStatus } from '@aston/middle-users-admin';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IFederationForm, IFederationUsersList } from 'apps/console/src/app/federations-module/models';
import { FederationUsersListSortProp } from 'apps/console/src/app/federations-module/enums';

export interface IFederationDetailState {
	activeModal: NgbModalRef;
	currentFederationId: number;
	federationForm: IStoreEntityStateSlice<IFederationForm>;
	federationFormIsEditing: boolean;
	usersList: IStoreListStateSlice<IFederationUsersList, FederationUsersListSortProp, IFilter>;
	transientUserStatus: IStoreEntityStateSlice<UserStatus>;
}

export const initialState: IFederationDetailState = {
	activeModal: null,
	currentFederationId: null,
	federationForm: createEntitySlice(),
	federationFormIsEditing: false,
	usersList: createListSlice({ prop: FederationUsersListSortProp.FIRSTNAME, isDesc: false }),
	transientUserStatus: createEntitySlice(),
};
